import styled from "@emotion/styled";
import { RegisterMemberListResponse } from ".";
import UI from "@mile-meeting/mile-ui";
import { roleStringList, roleStringListRemovedOwner, roleToString, stringToRole, UserRole } from "utils/role";
import { useRecoilValue } from "recoil";
import { member } from "recoil/recoilState";

const UserItem = ({
  user,
  onDelete,
  onChangeRole,
}: {
  user: RegisterMemberListResponse;
  onDelete?: () => void;
  onChangeRole?: (role: UserRole) => void;
}) => {
  const memberInfo = useRecoilValue(member);
  return (
    <Container>
      <div style={{ flex: 1, display: "flex", gap: "4px", flexDirection: "column", marginRight: "20px" }}>
        <UI.Typography
          type="body01 normal"
          fontStyle="regular"
          color={user.validationResult ? "var(--alias-color-label-normal)" : "var(--alias-color-status-negative)"}
        >
          {user.email}
        </UI.Typography>
        {user.validationResult === false && (
          <UI.Typography
            type="body01 normal"
            fontStyle="regular"
            color={user.validationResult ? "var(--alias-color-label-normal)" : "var(--alias-color-status-negative)"}
          >
            {user.errorMessage}
          </UI.Typography>
        )}
      </div>
      <UI.SelectBox
        style={{ marginRight: "24px" }}
        size="small"
        width={160}
        data={memberInfo?.role === UserRole.Owner ? roleStringList : roleStringListRemovedOwner}
        selectedData={[roleToString(user.role)]}
        onChange={(value) => onChangeRole?.(stringToRole(value[0]))}
      />
      <div>
        <UI.IconButton.Normal
          icon="removeCircle"
          size={24}
          color="var(--alias-color-label-alternative)"
          onClick={onDelete}
        />
      </div>
      <div style={{ width: "10px" }}></div>
    </Container>
  );
};

export default UserItem;

const Container = styled.div`
  display: flex;
  padding: 12px 24px;
  border-bottom: 1px solid var(--alias-color-line-normal);
  align-items: center;
`;
